export var AuctionItemStatus;
(function (AuctionItemStatus) {
    AuctionItemStatus["Prepared"] = "Prepared";
    AuctionItemStatus["Scheduled"] = "Scheduled";
    AuctionItemStatus["Available"] = "Available";
    AuctionItemStatus["Sold"] = "Sold";
    AuctionItemStatus["NotSold"] = "NotSold";
    AuctionItemStatus["SoldConfirmed"] = "SoldConfirmed";
    AuctionItemStatus["Completed"] = "Completed"; // 9
})(AuctionItemStatus || (AuctionItemStatus = {}));
export var AuctionStatus;
(function (AuctionStatus) {
    AuctionStatus["New"] = "New";
    AuctionStatus["Active"] = "Active";
    AuctionStatus["Aftersale"] = "Aftersale";
    AuctionStatus["Finished"] = "Finished";
})(AuctionStatus || (AuctionStatus = {}));
export var AuctionClassTypes;
(function (AuctionClassTypes) {
    AuctionClassTypes["COMBINED"] = "COMBINED";
    AuctionClassTypes["ONLINE"] = "ONLINE";
})(AuctionClassTypes || (AuctionClassTypes = {}));
export const SourceAuctionIdStorageKey = "SourceAuctionId";
export const AuctionListPageReturnUrlStorageKey = "AuctionListPageReturnUrlV1";
